var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevisitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33334C4.31826 1.33334 1.3335 4.31811 1.3335 8.00001C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00001C14.6668 4.31811 11.6821 1.33334 8.00016 1.33334ZM7.17912 4.26529C7.17912 4.04832 7.26531 3.84024 7.41873 3.68682C7.57215 3.5334 7.78023 3.44721 7.9972 3.44721C8.21417 3.44721 8.42225 3.5334 8.57567 3.68682C8.72909 3.84024 8.81528 4.04832 8.81528 4.26529V9.00186C8.81528 9.21883 8.72909 9.42691 8.57567 9.58033C8.42225 9.73375 8.21417 9.81994 7.9972 9.81994C7.78023 9.81994 7.57215 9.73375 7.41873 9.58033C7.26531 9.42691 7.17912 9.21883 7.17912 9.00186V4.26529ZM8.71746 12.2534C8.55202 12.4166 8.33515 12.5175 8.10375 12.5388C7.87234 12.5602 7.64069 12.5007 7.44818 12.3705C7.25566 12.2404 7.11419 12.0475 7.0478 11.8248C6.98142 11.6021 6.99423 11.3633 7.08405 11.149C7.17387 10.9347 7.33516 10.7581 7.54049 10.6492C7.74582 10.5404 7.98251 10.5061 8.2103 10.552C8.4381 10.598 8.64293 10.7215 8.78997 10.9014C8.93701 11.0814 9.01718 11.3067 9.01684 11.5391C9.01795 11.6722 8.99199 11.8042 8.94052 11.927C8.88906 12.0498 8.81317 12.1609 8.71746 12.2534Z",
    fill: "#D9B46B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisitIcon);
export default __webpack_public_path__ + "static/media/revisit-icon.156a69f9.svg";
export { ForwardRef as ReactComponent };